module.exports = __webpack_public_path__ + "img/rank3.83a5d999.png";